"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRegExpFromString = exports.stringParser = exports.defaultStringParser = exports.StringParser = void 0;
const nano_cache_class_1 = require("../../cache/nano-cache.class");
const __1 = require("..");
/**
 * Класс StringParser умеет парсить строки по указанным правилам (parsers[])
 *
 * Передаем набор парсеров и с помощью этого набора парсим содержимое строки
 * В результате у нас должна получиться регулярка из исходной строки
 *
 * Например `http://some-website.ru /may-be-regexp/mi #EVERYTHING# !!` -> `/http:\/\/some-website\.ru may-be-regexp .* !!/mi`
 */
class StringParser {
    constructor(parsers = [], options = {}) {
        var _a, _b;
        if (!Array.isArray(parsers)) {
            throw new Error('parsers must be an array!');
        }
        this.parsers = [];
        this.cache = typeof options.cache === 'undefined' ? new nano_cache_class_1.NanoCache() : (_a = options.cache) !== null && _a !== void 0 ? _a : null;
        this.RegExp = (_b = options.RegExp) !== null && _b !== void 0 ? _b : RegExp;
        const allMatches = [];
        parsers.forEach(parser => {
            if (typeof parser.match === 'string' &&
                typeof parser.handler === 'function') {
                this.parsers.push({
                    regexp: new this.RegExp(parser.match),
                    handler: parser.handler
                });
                allMatches.push(parser.match);
            }
        });
        const allMatchesStr = allMatches.join('|');
        this.reMatchAll = new this.RegExp(`(${allMatchesStr}|((.|\n|\r)*?(?=${allMatchesStr}|$)))`, 'g');
    }
    _str2regexp(string = '') {
        const match = string.match(this.reMatchAll);
        if (!match) {
            throw new Error('No matches found');
        }
        const parts = match.map(part => {
            if (!part) {
                return part;
            }
            const parser = this.parsers.find(({ regexp }) => regexp.test(part));
            if (parser === null || parser === void 0 ? void 0 : parser.regexp) {
                return parser.handler(part, part.match(parser.regexp));
            }
            return (0, __1.escapeRegexpSpecialCharacters)(part).replace(/(\r\n|\r|\n)/g, '\\r?\\n');
        });
        return new this.RegExp('^' + parts.join('') + '$');
    }
    makeRegExp(string = '') {
        if (this.cache) {
            return this.cache.once(string, () => this._str2regexp(string));
        }
        return this._str2regexp(string);
    }
}
exports.StringParser = StringParser;
/**
 * Набор дефолтных правил парсинга тэгов
 * Например `#ВСЕ#` будет парситься как `.*`
 */
const tags = [
    [['ВСЕ', 'EVERYTHING'], '.*'],
    [['ЦИФРЫ', 'Ц', 'DIGITS', 'D'], '\\d+?'],
    [['БУКВЫ', 'Б', 'LETTERS', 'L'], '[А-яЁё\\wÀ-ÿ]+?'],
    [['БУКВЫЦИФРЫ', 'БЦ', 'LETTERSDIGITS', 'LD'], '[А-яЁё\\wÀ-ÿ\\d]+?'],
    [['БУКВЫПРОБЕЛЫ', 'БП', 'LETTERSSPACES', 'LS'], '[А-яЁё\\wÀ-ÿ\\s]+?'],
    [['БУКВЫЦИФРЫПРОБЕЛЫ', 'БЦП', 'LETTERSDIGITSSPACES', 'LDS'], '[А-яЁё\\wÀ-ÿ\\d\\s]+?'],
    [['РУССКИЕБУКВЫ', 'РБ', 'RULETTERS', 'RL'], '[А-яЁё]+?'],
    [['РУССКИЕБУКВЫЦИФРЫ', 'РБЦ', 'RULETTERSDIGITS', 'RLD'], '[А-яЁё\\d]+?'],
    [['РУССКИЕБУКВЫПРОБЕЛЫ', 'РБП', 'RULETTERSSPACES', 'RLS'], '[А-яЁё\\s]+?'],
    [['РУССКИЕБУКВЫЦИФРЫПРОБЕЛЫ', 'РБЦП', 'RULETTERSDIGITSSPACES', 'RLDS'], '[А-яЁё\\d\\s]+?']
].reduce((result, tag) => {
    if (!tag[1] || typeof tag[1] !== 'string') {
        return result;
    }
    if (typeof tag[0] === 'string') {
        tag[0] = [tag[0]];
    }
    if (Array.isArray(tag[0])) {
        tag[0].forEach(t => {
            Object.assign(result, {
                [t.toLowerCase()]: tag[1]
            });
        });
    }
    return result;
}, {});
/**
 * Инстанс класса StringParser с дефолтными правилами парсинга регулярок
 */
exports.defaultStringParser = new StringParser([
    {
        // Правило для ссылок - оставляет их как есть в регулярке
        match: '([a-z]+://[^\\s]+)',
        handler: part => (0, __1.escapeRegexpSpecialCharacters)(part)
    },
    {
        // Правило для регулярок - оставляет только содержимое регулярки из строки
        match: '/((?![*+?])(?:[^\\r\\n\\[/\\\\]|\\\\.|\\[(?:[^\\r\\n\\]\\\\]|\\\\.)*\\])+)\\/((?:g(?:im?|mi?)?|i(?:gm?|mg?)?|m(?:gi?|ig?)?)?)',
        handler: (_part, match) => { var _a; return (_a = match === null || match === void 0 ? void 0 : match[1]) !== null && _a !== void 0 ? _a : ''; }
    },
    {
        // Правило для тэгов - подменяет тэг на предустановленную регулярку
        match: '#([A-zА-я_]+)#',
        handler: (_part, match) => { var _a; return (_a = (match && tags[match[1].toLowerCase()])) !== null && _a !== void 0 ? _a : ''; }
    },
    {
        // Правило для болтающихся пробелов в конце строки
        match: '(\\s+(\\r\\n|\\r|\\n))',
        handler: () => '\\s*?\\r?\\n'
    }
]);
/**
 * @deprecated Используйте defaultStringParser
 */
exports.stringParser = exports.defaultStringParser;
/**
 * Генерирует регулярку из любой строки используя дефолтный набор правил для парсинга
 */
const generateRegExpFromString = (string) => exports.defaultStringParser.makeRegExp(string);
exports.generateRegExpFromString = generateRegExpFromString;
//# sourceMappingURL=string-parser.class.js.map